import React, { useState } from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  FDSimpleAccordion, FDDeleteButton, FDPaper, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

const GOAL_RESOURCE_TYPE_TO_TITLE_MAP = {
  onboardingSaveForEducation: 'Education Goal',
  onboardingBuyAProperty: 'Property Goal',
  BuyAPropertyOutcome: 'Property Goal',
  buyAPropertyOutcome: 'Property Goal',
  GeneralSavingsOutcome: 'Custom Goal',
  generalSavingsOutcome: 'Custom Goal',
  saveForEducationOutcome: 'Education Goal',
  onboardingCustomGoal: '',
};

const getGoalTitle = (resource) => {
  let title = 'Goal';

  if (GOAL_RESOURCE_TYPE_TO_TITLE_MAP[resource.type()]) {
    title = GOAL_RESOURCE_TYPE_TO_TITLE_MAP[resource.type()];
  }
  if (resource.attr('type')) {
    title = `${resource.meta().field('type').option(resource.attr('type')).attr('prompt')} ${title}`;
  }
  if (resource.attr('goalRecipient')) {
    title = `${resource.meta().field('goalRecipient').option(resource.attr('goalRecipient')).attr('prompt')}'s ${title}`;
  }

  return title;
};

const GoalDetailItem = () => {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const isMobile = useMobileLayout();
  const { onboardingStepCollection, refreshOnboardingStepCollection, setOnboardingStepCollection } = useSurveyContext();
  const {
    resource,
  } = useMetaLayoutContext();
  const fields = resource.meta().template().list();

  const handleDelete = async () => {
    setLoading(true);
    try {
      // In the case of a new goal, we need to delete the goal resource itself
      if (!resource.id()) {
        // Get the parent collection of the resource
        const parentCollection = resource.getParentCollection();

        // filter out the deleted resource from the parent collection
        parentCollection.resources().filterItems((res) => res.instanceId() !== resource.instanceId());

        // set the onboarding step to the onboarding step resource to show the update
        await setOnboardingStepCollection(onboardingStepCollection);
        return;
      }
      // In the case of an existing goal, we need to delete the goal from the server
      if (resource.id()) {
        await resource.link('self').delete();
        await refreshOnboardingStepCollection();
      }
    } catch (e) {
      displayErrorMessage(e, e.errors || 'failed to delete a goal');
    } finally {
      setLoading(false);
    }
  };

  if (fields.length > 3 || isMobile) {
    const title = getGoalTitle(resource);

    return (
      <FDPaper width={'100%'} maxWidth={'450px'}>
        <FDSimpleAccordion expanded={open} onChange={() => setOpen(!open)} title={title}>
          <FDStack spacing={1} direction={'column'} alignItems={'center'} width={'100%'}>
            {fields.map((field) => <MetaControlField attr={field.attr('name')} key={field.attr('name')} fullWidth simpleRootStyle />)}
            <FDDeleteButton appearance={'secondary'} onClick={handleDelete} loading={loading} />
          </FDStack>
        </FDSimpleAccordion>
      </FDPaper>
    );
  }
  return (
    <FDPaper padding={2} width={'100%'}>
      <FDStack spacing={1} direction={'row'} alignItems={'center'} width={'100%'}>
        {fields.map((field) => <MetaControlField attr={field.attr('name')} key={field.attr('name')} simpleRootStyle />)}
        <FDDeleteButton appearance={'secondary'} onClick={handleDelete} />
      </FDStack>
    </FDPaper>
  );
};

GoalDetailItem.defaultProps = {};

GoalDetailItem.propTypes = {};

export { GoalDetailItem };
